import React from "react";

const Contact = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-primary-dark/5 to-primary/10 text-center">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto animate-fade-in">
            <span className="inline-block text-accent font-semibold text-sm uppercase tracking-widest mb-4">
              Get in Touch
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-heading">
              We'd Love to Hear From You
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Have questions about our programs, want to volunteer, or just want
              to say hello? Reach out to us and we'll get back to you as soon as
              possible.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-8 font-heading">
                Contact Information
              </h2>

              <div className="space-y-8">
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center text-2xl flex-shrink-0 text-primary">
                    📍
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      Our Office
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      Hotel Jyoti Tourist, Main Market Ghansali, Tehri Garhwal,
                      Uttarakhand - 249155
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center text-2xl flex-shrink-0 text-primary">
                    🌐
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      Website
                    </h3>
                    <a
                      href="https://darimindia.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary font-medium hover:underline"
                    >
                      darimindia.org
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center text-2xl flex-shrink-0 text-primary">
                    📧
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      Email Us
                    </h3>
                    <p className="text-gray-600 mb-1">General Inquiries:</p>
                    <a
                      href="mailto:info@darimindia.org"
                      className="text-primary font-medium hover:underline"
                    >
                      info@darimindia.org
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center text-2xl flex-shrink-0 text-primary">
                    📞
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      Call Us
                    </h3>
                    <p className="text-gray-600 mb-1">
                      Mon-Fri from 9am to 6pm:
                    </p>
                    <a
                      href="tel:+918979151025"
                      className="text-primary font-medium hover:underline"
                    >
                      +91 8979151025
                    </a>
                  </div>
                </div>
              </div>

              {/* Google Map */}
              <div className="mt-12 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3529.5678901234!2d78.6557413!3d30.4289219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDI1JzQ0LjEiTiA3OMKwMzknMjEuNCJF!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="256"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-64"
                  title="DARIM NGO Office Location - Main Market Ghansali, Tehri Garhwal"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-gray-50 p-8 md:p-10 rounded-3xl shadow-lg border border-gray-100">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 font-heading">
                Send a Message
              </h2>
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Your Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all"
                      placeholder="Full Name "
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all"
                      placeholder="Email"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="subject"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Subject
                  </label>
                  <select
                    id="subject"
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all bg-white"
                  >
                    <option value="">Select a topic</option>
                    <option value="volunteer">Volunteering</option>
                    <option value="donation">Donation Inquiry</option>
                    <option value="partnership">Partnership</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows="5"
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all resize-none"
                    placeholder="How can we help you?"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full py-4 bg-gradient-to-r from-primary to-primary-light text-white rounded-xl text-lg font-bold shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
